/**
 * i18n admin (E15) — namespace JSON dùng chung vi/en cho CHROME + nhãn UI.
 * Dữ liệu người dùng (fake data VN) KHÔNG dịch — chỉ nhãn điều hướng/bảng qua i18n.
 * Khác với `features/locale` (quản trị locale hệ thống ở tầng backend).
 * US-AE.F0-0000-S02.
 */
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import vi from "@/i18n/vi.json";
import en from "@/i18n/en.json";

const STORAGE_KEY = "gp_admin_lang";

function initialLang(): "vi" | "en" {
  const saved =
    typeof localStorage !== "undefined" ? localStorage.getItem(STORAGE_KEY) : null;
  return saved === "en" ? "en" : "vi";
}

void i18n.use(initReactI18next).init({
  resources: { vi: { translation: vi }, en: { translation: en } },
  lng: initialLang(),
  fallbackLng: "vi",
  interpolation: { escapeValue: false },
  // Key thiếu → trả về key (không crash). react-i18next default parseMissingKeyHandler=key.
  returnNull: false,
});

/** Đổi ngôn ngữ: set <html lang>, lưu localStorage, changeLanguage. */
export function setLang(lng: "vi" | "en"): void {
  if (typeof localStorage !== "undefined") localStorage.setItem(STORAGE_KEY, lng);
  if (typeof document !== "undefined") document.documentElement.setAttribute("lang", lng);
  void i18n.changeLanguage(lng);
}

export default i18n;
